import { CustomView, StartupMails } from "./types/customViews";

export class CustomViewState {
    public viewsRecordById: Record<string, CustomView> = {};

    public startupMails: StartupMails = {
        focusMailsInternetMessageIds: [],
        favoriteCustomViewsMailsInternetMessageIds: [],
        otherViewsMailsInternetMessageIds: [],
    };
}
